import { configureStore } from "@reduxjs/toolkit";
import RegisterReducer from "./Slice/RegisterSlice";
import loginReducer from "./Slice/loginSlice";
import VendorManagementReducer from "./Slice/VendorManagementSlice";
import CoordinatorManagementReducer from "./Slice/CoordinatorManagementSlice";
import ServiceManagementReducer from "./Slice/ServiceManagementSlice";
import EventManagementReducer from "./Slice/EventManagementSlice";
import CalenderReducer from "./Slice/CalenderSlice";

export default configureStore({
  reducer: {
    RegisterR: RegisterReducer,
    loginR: loginReducer,
    VendorManagementR: VendorManagementReducer,
    CoordinatorManagementR: CoordinatorManagementReducer,
    ServiceManagementR: ServiceManagementReducer,
    EventManagementR: EventManagementReducer,
    CalenderR: CalenderReducer,
  },
});
